import { render } from "./BootstrapFlashMessage.vue?vue&type=template&id=c79d7816"
import script from "./BootstrapFlashMessage.vue?vue&type=script&lang=js"
export * from "./BootstrapFlashMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__